import { IIdentifiable } from '@/common/models/models'

interface ICollaborationEntryType extends IIdentifiable {
    type: string
}

class CollaborationEntryType implements ICollaborationEntryType {
    id = 0
    type = ''

    constructor (dto?: ICollaborationEntryType) {
        if (dto) {
            this.id = dto.id
            this.type = dto.type
        }
    }
}

export {
    ICollaborationEntryType, CollaborationEntryType
}
